const map = {
	"./bouncing_marker_high_DoB.gif": 2127,
	"./bouncing_marker_high_animal.gif": 864,
	"./bouncing_marker_high_boat.gif": 9598,
	"./bouncing_marker_high_deformation.gif": 9754,
	"./bouncing_marker_high_electric-tower.gif": 1201,
	"./bouncing_marker_high_intrusion.gif": 8467,
	"./bouncing_marker_high_landslide.gif": 8350,
	"./bouncing_marker_high_leaks.gif": 92,
	"./bouncing_marker_high_machinery.gif": 9468,
	"./bouncing_marker_high_manhole.gif": 9926,
	"./bouncing_marker_high_rock-falling.gif": 4217,
	"./bouncing_marker_high_submarine_impact.gif": 1581,
	"./bouncing_marker_high_temperature.gif": 7050,
	"./bouncing_marker_high_vehicle.gif": 9808,
	"./bouncing_marker_intermediate_DoB.gif": 8800,
	"./bouncing_marker_intermediate_animal.gif": 4921,
	"./bouncing_marker_intermediate_boat.gif": 1243,
	"./bouncing_marker_intermediate_deformation.gif": 5097,
	"./bouncing_marker_intermediate_electric-tower.gif": 4400,
	"./bouncing_marker_intermediate_intrusion.gif": 7744,
	"./bouncing_marker_intermediate_landslide.gif": 181,
	"./bouncing_marker_intermediate_leaks.gif": 9187,
	"./bouncing_marker_intermediate_machinery.gif": 8359,
	"./bouncing_marker_intermediate_manhole.gif": 5397,
	"./bouncing_marker_intermediate_rock-falling.gif": 2036,
	"./bouncing_marker_intermediate_submarine_impact.gif": 5364,
	"./bouncing_marker_intermediate_temperature.gif": 1473,
	"./bouncing_marker_intermediate_vehicle.gif": 6715,
	"./bouncing_marker_low_DoB.gif": 3795,
	"./bouncing_marker_low_animal.gif": 20,
	"./bouncing_marker_low_boat.gif": 6477,
	"./bouncing_marker_low_deformation.gif": 2830,
	"./bouncing_marker_low_electric-tower.gif": 9957,
	"./bouncing_marker_low_intrusion.gif": 9695,
	"./bouncing_marker_low_landslide.gif": 3218,
	"./bouncing_marker_low_leaks.gif": 8336,
	"./bouncing_marker_low_machinery.gif": 5800,
	"./bouncing_marker_low_manhole.gif": 2178,
	"./bouncing_marker_low_rock-falling.gif": 9789,
	"./bouncing_marker_low_submarine_impact.gif": 3345,
	"./bouncing_marker_low_temperature.gif": 998,
	"./bouncing_marker_low_vehicle.gif": 8532
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6427;